var url = "f8e9b1762ccb9cfc7769795cc7ce4e3c.png";
var cdnUrl = typeof _wml !== "undefined" && _wml.cdn && _wml.cdn.map(url);
module.exports = cdnUrl || __webpack_public_path__ + url;